// import Groq from "groq-sdk";
import { openRouter } from './openRouterClient'

// const groq = new Groq({
//     apiKey: process.env.REACT_APP_GROQ_API_KEY,
// })




const systemPrompt = `
You are an assistant that extracts structured job search filters from a user's natural language query.

Return ONLY a raw JSON object. Do not use Markdown formatting. Do not use code blocks.

--- ALLOWED FIELDS ---
- campany_name (string)
- role_title (string)
- skills_required (array of strings)
- location (string)
- job_type (string)
- job_level (string or object)
- sort (string: "latest", "oldest", "salary")

--- LOGIC RULES ---
1. If the user types a single keyword (e.g., "web", "react", "accounting"), keep it as-is (do NOT expand it into a longer title). Put it in "role_title" and/or "skills_required".
2. If the query is very short (1-3 characters like "ai", "hr", "qa"), keep it EXACTLY as provided so partial matching works.
2. Do not invent fields that are not listed above.
3. Default "sort" to "latest" if not specified.

--- EXAMPLE ---
User: web
Output: { "role_title": "Web Developer", "skills_required": ["Web"], "sort": "latest" }

User: python jobs in lagos
Output: { "skills_required": ["Python"], "location": "Lagos", "sort": "latest" }
`;


export const getJobSearchFiltersFromLLM = async (userQuery) => {
  try {
    const q = (userQuery || "").trim();

    // For very short queries, bypass the LLM to avoid "helpful" expansions
    // like "ai" -> "AI Specialist" which makes search too strict.
    if (q.length > 0 && q.length <= 3) {
      return {
        role_title: q,
        skills_required: [q],
        sort: "latest",
      };
    }

    const response = await openRouter.chat([
      { role: "system", content: systemPrompt }, 
      { role: "user", content: userQuery }
    ]);

    // 1. CLEAN THE RESPONSE (Remove Markdown code blocks)
    let cleanJson = response.replace(/```json/g, "").replace(/```/g, "").trim();

    // 2. PARSE
    const parsedData = JSON.parse(cleanJson);

    return parsedData;
  } catch (error) {
    console.error("LLM Parsing error:", error.message);
    // Return null so the Action knows to use the fallback
    return null;
  }
}